import type { InternalAxiosRequestConfig } from 'axios';

/**
 * SOLO rama de integración (joan/ISF3-108/integration/onboarding-ci), no va a release:
 * en modo `ci`, las peticiones a `company/b2b/...` contra la API de CI van al ms-company que el back
 * expone con ngrok, para probar sus cambios en caliente sin esperar el pipeline.
 * `company/ext/...` (login, registro, contraseña) no se desvía: no depende de que ngrok esté arriba.
 */
export const COMPANY_OVERRIDE_BASE_URL = 'https://unmanaged-magenta-perky.ngrok-free.dev/';

const COMPANY_PATH_PATTERN = /^\/?company\/b2b\//;

/** Sin esta cabecera, ngrok gratis responde su página de aviso en vez de la API. */
const NGROK_SKIP_WARNING_HEADER = 'ngrok-skip-browser-warning';

interface CompanyOverrideOptions {
  mode: string;
  defaultBaseUrl: string;
}

/**
 * Redirige al back de ngrok las peticiones relativas a `company/b2b/...` que salen con la URL base de CI.
 * Fuera del modo `ci`, con otra URL base o con otra ruta, devuelve la configuración sin cambios.
 */
export function applyCompanyOverride(
  config: InternalAxiosRequestConfig,
  { mode, defaultBaseUrl }: CompanyOverrideOptions = {
    mode: import.meta.env.MODE,
    defaultBaseUrl: import.meta.env.VITE_BASE_URL,
  }
): InternalAxiosRequestConfig {
  const isCompanyRequest = COMPANY_PATH_PATTERN.test(config.url ?? '');
  if (mode !== 'ci' || !isCompanyRequest || config.baseURL !== defaultBaseUrl) return config;

  config.baseURL = COMPANY_OVERRIDE_BASE_URL;
  config.headers.set(NGROK_SKIP_WARNING_HEADER, 'true');
  return config;
}
